import React from 'react';
import { Link } from 'react-router-dom';
import ReactDOM from 'react-dom';

class Footer extends React.Component {
  constructor(props){
    super(props);
  }

  render(){
    return(
      <div className="footer">
        <h1>FOOTER HERE</h1>
      </div>
    );
  }

}

export default Footer;



// WEBPACK FOOTER //
// ./frontend/components/footer/footer.jsx